import UserManagementRoutes from './user-management-route'
import ProjectManagementRoutes from './project-management-route'

export default [...ProjectManagementRoutes, ...UserManagementRoutes]
